import script from "./sf-text-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-text-avatar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__